import React from 'react';

class WeeksDropDown extends React.Component {

  constructor(props) {
		super(props);
		this.weekChange = this.weekChange.bind(this);
		this.createSelectWeek = this.createSelectWeek.bind(this);
	}

	weekChange(event) {
		this.props.weekChange(parseInt(event.target.value));
	}

	render() {
		//console.log('WeeksDropDown: render')
		var weeksRows = [];
		for (var i = 1; i <= (this.props.numberOfWeeks); i++) {
			weeksRows.push(this.createSelectWeek(i));
		}

		return (
			<select className="form-control" name="weekSelect" value={this.props.week} onChange={this.weekChange}>
				{weeksRows}
			</select>
		);
	}

	createSelectWeek(i) {
		return (
			<option key={'w'+i} value={i}>{i}</option>
		);
	}
	
}

export default WeeksDropDown;